import Inspection from './Inspection.container';
export default Inspection;
